import Flux from 'lib/flux';
import ConversationConstants from 'constants/conversation';

const ConversationStore = Flux.createStore({
  name: 'conversation',

  getInitialState() {
    return {
      creating: false,
      createCompleted: false,
      createFailed: false,
      createError: null,
    };
  },

  actions: [
    [
      ConversationConstants.CREATE,
      function (_contents) {
        this.state = this.state.merge({
          creating: true,
          createCompleted: false,
          createFailed: false,
          createError: {},
        });
      },
    ],

    [
      ConversationConstants.CREATE_COMPLETED,
      function () {
        this.state = this.state.merge({
          creating: false,
          createCompleted: true,
          createFailed: false,
          createError: null,
        });
      },
    ],

    [
      ConversationConstants.CREATE_FAILED,
      function (payload) {
        this.state = this.state.merge({
          creating: false,
          createCompleted: false,
          createFailed: true,
          createError: payload.responseJSON.message,
        });
      },
    ],
  ],
});

export default ConversationStore;
